import { createContext } from "react";

const CooperativeContext = createContext();

export default CooperativeContext;